// eslint-disable-next-line @typescript-eslint/no-var-requires
const baseTheme = require('./base');

const theme = JSON.parse(JSON.stringify(baseTheme)); // deep clone
theme.site = 'Cymbria';
theme.color.primary = theme.color.black;
theme.color.secondary = theme.color.orange;
theme.spacing = {
  s1: '8px',
  s2: '16px',
  s3: '24px',
  s4: '32px',
  m1: '40px',
  m2: '48px',
  m3: '56px',
  m4: '64px',
  l1: '72px',
  l2: '80px',
  l3: '88px',
  l4: '96px',
};
theme.fontSize = {
  smaller: '12px',
  small: '14px',
  body: '16px',
  caption: '18px',
  h4: '22px',
  h3: '26px',
  h2: '28px',
  h1: '36px',
  s1: '46px',
};
theme.typography = {
  s1: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.s1};
  font-weight: ${theme.fontWeight.semiBold};
  `,
  s2: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.h2};
  font-weight: ${theme.fontWeight.semiBold};
  line-height: ${theme.lineHeight.xxs};
  `,
  h1: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.h1};
  font-weight: ${theme.fontWeight.bold};
  `,
  h2: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.h2};
  font-weight: ${theme.fontWeight.bold};
  `,
  h3: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.h3};
  font-weight: ${theme.fontWeight.semiBold};
  line-height: ${theme.lineHeight.xs};
  `,
  h4: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.h4};
  font-weight: ${theme.fontWeight.regular};
  line-height: ${theme.lineHeight.xs};
  `,
  subheading: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.body};
  font-weight: ${theme.fontWeight.semiBold};
  line-height: ${theme.lineHeight.normal};
  `,
  body: `
  font-family: ${theme.fontFamily.body};
  font-size: ${theme.fontSize.body};
  font-weight: ${theme.fontWeight.light};
  line-height: ${theme.lineHeight.normal};
  `,
  callout: `
  font-family: ${theme.fontFamily.body};
  font-size: ${theme.fontSize.h2};
  font-weight: ${theme.fontWeight.light};
  line-height: ${theme.lineHeight.sm};
  `,
  caption: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.caption};
  font-weight: ${theme.fontWeight.bold};
  `,
  date: `
  font-family: ${theme.fontFamily.body};
  font-size: ${theme.fontSize.body};
  font-weight: ${theme.fontWeight.light};
  line-height: ${theme.lineHeight.xxs};
  font-style: italic;
  `,
  nav: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.medium};
  `,
  navClick: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.bold};
  `,
  navLink: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.regular};
  `,
  footerTitle: `
  font-family: ${theme.fontFamily.heading};
  font-size: ${theme.fontSize.body};
  font-weight: ${theme.fontWeight.bold};
  `,
  footerBody1: `
  font-family: ${theme.fontFamily.body};
  font-size: ${theme.fontSize.body};
  font-weight: ${theme.fontWeight.light};
  line-height: ${theme.lineHeight.lg};
  `,
  footerBody2: `
  font-family: ${theme.fontFamily.body};
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.regular};
  `,
  footerBody3: `
  font-family: ${theme.fontFamily.body};
  font-size: ${theme.fontSize.smaller};
  font-weight: ${theme.fontWeight.light};
  line-height: ${theme.lineHeight.md};
  `,
  tag: `
  font-family: ${theme.fontFamily.body};
  font-size: ${theme.fontSize.smaller};
  font-weight: ${theme.fontWeight.medium};
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${theme.color.secondary};
  `,
};
theme.mobileTypography = {
  h1: `
  font-family: ${theme.fontFamily.heading};
  font-size: 26px;
  font-weight: ${theme.fontWeight.bold};
  `,
  h2: `
  font-family: ${theme.fontFamily.heading};
  font-size: 22px;
  font-weight: ${theme.fontWeight.bold};
  `,
  h3: `
  font-family: ${theme.fontFamily.heading};
  font-size: 22px;
  font-weight: ${theme.fontWeight.semiBold};
  line-height: 1.3;
  `,
  h4: `
  font-family: ${theme.fontFamily.heading};
  font-size: 18px;
  font-weight: ${theme.fontWeight.medium};
  line-height: 1.3;
  `,
  s1: `
  font-family: ${theme.fontFamily.heading};
  font-size: 36px;
  font-weight: ${theme.fontWeight.semiBold};
  `,
  s2: `
  font-family: ${theme.fontFamily.heading};
  font-size: 22px;
  font-weight: ${theme.fontWeight.semiBold};
  line-height: 1.2;
  `,
  subheading: `
  font-family: ${theme.fontFamily.heading};
  font-size: 12px;
  font-weight: ${theme.fontWeight.semiBold};
  line-height: 1.5;
  `,
  callout: `
  font-family: ${theme.fontFamily.body};
  font-size: 20px;
  font-weight: ${theme.fontWeight.light};
  line-height: 1.35;
  `,
  button: `
  font-family: ${theme.fontFamily.heading};
  font-size: 12px;
  font-weight: ${theme.fontWeight.medium};
  `,
  footerTitle: `
  font-family: ${theme.fontFamily.body};
  font-size: 12px;
  font-weight: ${theme.fontWeight.bold};
  `,
  footerBody1: `
  font-family: ${theme.fontFamily.body};
  font-size: 12px;
  font-weight: ${theme.fontWeight.light};
  line-height: 2.2;
  `,
  footerBody2: `
  font-family: ${theme.fontFamily.body};
  font-size: 10px;
  font-weight: ${theme.fontWeight.regular};
  `,
  footerBody3: `
  font-family: ${theme.fontFamily.body};
  font-size: 10px;
  font-weight: ${theme.fontWeight.light};
  line-height: ${theme.lineHeight.md};
  `,
};
module.exports = theme;
